import ProductInfoPanel from "./productInfoPanel";

export default ProductInfoPanel;